import classNames from "classnames";
import type { FC } from "react";
import { AppDialog } from "../../../shared/components/AppDialog";
import { ModalBasicFooter } from "./ModalBasicFooter";
import { ModalBasicHeader } from "./ModalBasicHeader";
import styles from "./styles.module.css";
import type { ModalBasicProps } from "./types";

interface Props extends ModalBasicProps {
  onOk?: () => void;
  onCancel?: () => void;
  hasHeader?: boolean;
  disabledOkBtn?: boolean;
  disabledCancelBtn?: boolean;
  buttonOkText?: string;
  hasHeaderPaddingBottom?: boolean;
  onCancelText?: string;
  isWarningButton?: boolean;
  footerClassName?: string;
}

export const ModalBasic: FC<Props> = ({
  title,
  children,
  hasCloseButton,
  hasActions,
  hasHeader = true,
  closeModal,
  onOk,
  onCancel,
  hasFooter,
  disabledOkBtn,
  buttonOkText,
  disabledCancelBtn,
  isWarningButton = false,
  hasHeaderPaddingBottom = true,
  onCancelText,
  footerClassName,
  ...props
}) => {
  return (
    <AppDialog
      classes={{
        paper: classNames(styles.modal, footerClassName),
      }}
      {...props}
    >
      <div className={styles["modal-container"]}>
        {(title || hasCloseButton) && (
          <ModalBasicHeader
            title={title as string}
            hasCloseButton={hasCloseButton}
            onClick={closeModal}
            className={classNames({
              [styles["header-padding"]]: !hasHeaderPaddingBottom,
            })}
          />
        )}
        {children}
        {hasFooter && (
          <ModalBasicFooter
            onOk={onOk}
            onCancel={onCancel}
            buttonOkText={buttonOkText}
            disabledCancelBtn={disabledCancelBtn}
            disabledOkBtn={disabledOkBtn}
            onCancelText={onCancelText}
            isWarningButton={isWarningButton}
            footerClassName={footerClassName}
          />
        )}
      </div>
    </AppDialog>
  );
};
